module.exports = __webpack_public_path__ + "img/image_003.d69763d0.png";